<span *ngIf="isActiveLink">
  <a
    [class]="cssStyles"
    (click)="onSubmit()"
    [routerLink]="url"
    [queryParams]="urlParams"
    [target]="openInNewWindow ? '_blank' : '_self'"
    data-test-id="link-active"
    >{{ text }}</a
  ><ng-template *ngIf="statusMark" [ngTemplateOutlet]="statusMarkTemplate"></ng-template
  ><ng-template *ngIf="needComma" [ngTemplateOutlet]="commaTemplate"></ng-template
></span>

<span *ngIf="!isActiveLink">
  <span data-test-id="link-text" [class]="cssStyles">{{ text }}</span
  ><ng-template *ngIf="statusMark" [ngTemplateOutlet]="statusMarkTemplate"></ng-template
  ><ng-template *ngIf="needComma" [ngTemplateOutlet]="commaTemplate"></ng-template
></span>

<ng-template #commaTemplate><span data-test-id="comma" [innerHTML]="',&nbsp;'"></span></ng-template>

<ng-template #statusMarkTemplate
  ><span data-test-id="link-annotation" [class]="cssStyles" class="text-muted ps-2">{{
    getStatusMark() | translate
  }}</span></ng-template
>
